<div class="pdf-page app-aul-014-24" id="aul01424">
  <!-- <app-policy-header></app-policy-header>-->
  <p class="font-large" style="text-align: center">
    <b>MINIMUM EARNED PREMIUM ENDORSEMENT</b>
  </p>
  <p class="font-large">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
  </p>
  <p class="font-small">
    <b>
      This endorsement provides the terms and conditions for calculation of
      return premium in the event of cancellation and deletions, including the
      minimum earned premium applicable and retained by us. To the extent a
      provision of the policy or a previous endorsement is inconsistent with an
      express provision of this endorsement, this endorsement controls.</b
    >
  </p>
  <br />
  <ol class="font-small spaced-list">
    <li style="padding-bottom: 5px;">
      If this insurance policy is cancelled by <b>You</b>, at your request, the
      premium refund will be determined and calculated as follows:
      <ol class="mt-3" style="list-style-type: lower-alpha">
        <li style="padding-bottom: 5px;">
          The return premium to be refunded will be equal to 75% of the Total Policy Premium or 90% of 
          the unearned premium under the policy as of the effective date of cancellation, whichever the lesser.  
        </li>
        <li style="padding-bottom: 5px;">
          If this Policy has been extended beyond the end of the Policy Period and the Policy is 
          cancelled at any time during such extended Policy Period, there will be no return premium refunded. 
        </li>
        <li style="padding-bottom: 5px;">
          Cancellation for nonpayment of premium is considered a request by the first Named Insured for 
          cancellation of this policy. The return premium to be refunded will be determined and calculated 
          in accordance with the applicable clause above.  
        </li>
      </ol>
    </li>
    <li style="padding-bottom: 5px;">
      If this insurance policy is cancelled by <b>Us</b>, the premium refund
      will be determined and calculated as follows:
      <ol class="mt-3" style="list-style-type: lower-alpha">
        <li style="padding-bottom: 5px;">
          The return premium to be refunded will be equal to the unearned
          premium under the policy as of the effective date of cancellation.
        </li>
        <li style="padding-bottom: 5px;">
          If this Policy has been extended beyond the end of the Policy Period
          and the Policy is cancelled at any time during such extended Policy
          Period, there will be no return premium refunded.
        </li>
      </ol>
    </li>
  </ol>
</div>
